module.exports = __webpack_public_path__ + "static/img/icon_breadcrumb_arrow.47af829.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_breadcrumb_arrow.svg
// module id = xt/r
// module chunks = 10